import React from 'react';
import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import CircledBackArrow from 'components/Icons/CircledBackArrow';

export interface BackButtonProps {
  onClick: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Box paddingBottom="2em">
      <Button onClick={onClick} startIcon={<CircledBackArrow />}>
        {t('back')}
      </Button>
    </Box>
  );
};

export default BackButton;
